import { useCallback } from 'react'
import ButtonModalSortList, { ItemSortFunction } from '../../../../../../../../../baseComponents/Sorts/ButtonModalSortList'
import { BaseButtonModalSortListProps } from '../../../../../../../../../baseComponents/Sorts/ButtonModalSortList/types'
import { twinFetchPostText } from '../../../../../../../../../utils/globals/data'
import { TwinDictionary } from '../../../../../../../../../utils/globals/dictionary'

type CategoryAddonSortButtonProps = CategoryAddonSortButtonLogicProps & BaseButtonModalSortListProps & {
    extraWhereParams: TwinDictionary
    urlGetData: string
}

const CategoryAddonSortButton: React.FC<CategoryAddonSortButtonProps> = ({ urlGetData, url, ...rest }) => {
    const { updateOrder } = useCategoryAddonSortButtonLogic({ url })
    return (
        <ButtonModalSortList updateData={updateOrder} getDataFrom={urlGetData} {...rest} />
    )
}

interface CategoryAddonSortButtonLogicProps {
    url: string
}

const useCategoryAddonSortButtonLogic = ({ url }: CategoryAddonSortButtonLogicProps) => {
    const updateOrder: ItemSortFunction = useCallback(async (data) => {
        const res = await twinFetchPostText(url, { categoryAddons: data })
        if (res) {
            return true
        }
        return false
    }, [url])

    return { updateOrder }
}

export default CategoryAddonSortButton